import { render, staticRenderFns } from "./zsmglMain.vue?vue&type=template&id=04a13da2&scoped=true&"
import script from "./zsmglMain.vue?vue&type=script&lang=js&"
export * from "./zsmglMain.vue?vue&type=script&lang=js&"
import style0 from "./zsmglMain.vue?vue&type=style&index=0&id=04a13da2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a13da2",
  null
  
)

export default component.exports